// 当前页面埋点事件标题
export enum eEventTitle {
  CHANGE_AGENDA_TAB_EXPANDED = 'change_agenda_tab_expanded', // 章节速览的打开和关闭
  CHANGE_QNA_REVIEW_TAB_EXPANDED = 'change_qnaReview_tab_expanded', // 问答回顾 打开和关闭
  CHANGE_HIGHLIGHTS_TAB_EXPANDED = 'change_highlights_tab_expanded', // 要点回顾打开和关闭
  CHANGE_TO_DO_LIST_TAB_EXPANDED = 'change_toDoList_tab_expanded', // 待办纪要
  REVIEW_QNA_REVIEW_TAB = 'review_qnaReview_tab', // 在智能速览的列表中问答回顾 点击回顾的人数&次数
  REVIEW_HIGHLIGHTS_TAB = 'review_highlights_tab', // 在智能速览的列表中要点回顾 点击回顾的人数&次数
  COPY_QNA_REVIEW_TAB = 'copy_qnaReview_tab', // 问答回顾 复制 人数&次数
  COPY_HIGHLIGHTS_TAB = 'copy_highlights_tab', // 要点回顾 复制 人数&次数
}

export enum Tabs {
  Agenda = 'Agenda', // 章节速览
  SpeakerSummary = 'SpeakerSummary', // 发言总结
  PPT = 'PPT', // PPT
  Highlights = 'Highlights', // 要点回顾
  QNAReview = 'QNAReview', // 问答回顾
  ToDoList = 'ToDoList', // 待办事项
  Summary = 'Summary', // 全文概要
}

// 主题
export enum eTheme {
  TAB_ITEM = 'TAB_ITEM',
  SUMMARY_ITEM = 'SUMMARY_ITEM',
}
